import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { MobileContactBar } from "@/components/MobileContactBar";
import { SmoothScroll } from "@/components/SmoothScroll";
import { useSEO } from "@/hooks/useSEO";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

const HOME_SEO = { title: "Tractor, Implement & Backhoe Loader Parts Exporter | Ocean Exports", description: "Ocean Exports supplies aftermarket parts for agricultural tractors (Massey Ferguson, Ford, New Holland, John Deere), agricultural implements, and Case & JCB backhoe loaders — with 3-point linkage parts as our core strength." };
const NOT_FOUND_SEO = { title: "Page Not Found | Ocean Exports", description: "The page you're looking for doesn't exist.", noindex: true };

const SEO_BY_PATH = {
  "/": HOME_SEO,
  "/parts": { title: "Tractor, Implement & Backhoe Loader Parts Catalogue | Ocean Exports", description: "Browse our aftermarket parts catalogue — Massey Ferguson, John Deere, Ford and New Holland tractor parts, JCB & Case backhoe loader parts, and 3-point linkage components." },
  "/about": { title: "About Ocean Exports — Terramech Components Inc. & LAV-TEK", description: "Learn about Ocean Exports and our divisions, Terramech Components Inc. and LAV-TEK, supplying aftermarket tractor and machinery parts internationally." },
  "/quality-supply": { title: "Quality & Supply Process | Ocean Exports", description: "Our approach to component selection, inspection, packaging and international dispatch for aftermarket tractor and machinery parts." },
  "/request-a-quote": { title: "Request a Parts Quote | Ocean Exports", description: "Send your part number, machine details or a component photo to get a quotation for aftermarket tractor, implement or backhoe loader parts." },
  "/faq": { title: "Frequently Asked Questions | Ocean Exports", description: "Answers to common questions about requesting parts, fitment, orders and contacting Ocean Exports." },
  "/gallery": { title: "Parts Gallery | Ocean Exports", description: "Browse photos of our tractor, implement, backhoe loader and 3-point linkage parts by category." },
  "/contact": { title: "Contact Us | Ocean Exports", description: "Get in touch with Ocean Exports by phone, WhatsApp or email for aftermarket tractor and machinery parts enquiries." },
  "/privacy": { title: "Privacy Policy | Ocean Exports", description: "How Ocean Exports handles information submitted through enquiry forms." },
  "/terms": { title: "Terms & Conditions | Ocean Exports", description: "Terms governing use of the Ocean Exports website and enquiry process." },
};

function SEOManager() {
  const { pathname } = useLocation();
  const seo = SEO_BY_PATH[pathname] || NOT_FOUND_SEO;
  useSEO({ ...seo, path: pathname });
  return null;
}

export function Layout() {
  return (
    <div className="App flex min-h-screen flex-col">
      <SmoothScroll />
      <ScrollToTop />
      <SEOManager />
      <Header />
      <main className="flex-1 pb-16 lg:pb-0">
        <Outlet />
      </main>
      <Footer />
      <MobileContactBar />
    </div>
  );
}
